import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputSwitch} from "primereact/inputswitch";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";

const BankaccountNumberFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    currency: process.env.REACT_APP_CURRENCY_DEFAULT
  });
  const [newFormData, setNewFormData] = useState({});

  const [companyOptions, setCompanyOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);

  const validate = (data) => {
    let errors = {};
    return errors;
  };

  const formatAccountNumber = (raw) => {
    const digitsOnly = raw.replace(/\D/g, '');
    const parts = [];
    for (let i = 0; i < digitsOnly.length; i += 8) {
      parts.push(digitsOnly.slice(i, i + 8));
    }
    return parts.slice(0, 3).join('-');
  }

  const formatIban = (raw) => {
    const alnum = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
    const parts = [];
    for (let i = 0; i < alnum.length; i += 4) {
      parts.push(alnum.slice(i, i + 4));
    }
    return parts.join(' ');
  }

  const formatSwift = (raw) => {
    const cleaned = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
    return cleaned.slice(0, 11);
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const onSubmit = (data) => {
    setLoading(true);
    const payload = {
      company: formData.company,
      currency: formData.currency,
      name: formData.name ?? '',
      account_number: formData.account_number ?? '',
      iban: formData.iban ?? '',
      swift: formData.swift ?? '',
      external_id: formData.external_id ?? '',
      active: !!formData.active,
      default: !!formData.default,
    };

    if (action === 'update' && id) {
      apiCall('patch', '/api/v2/bank-account/' + id, payload)
        .then(() => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderBankaccountNumberList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow(
            'error',
            t('error'),
            error.toString(),
            '',
            error.response
          );
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/bank-account', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderBankaccountNumberList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/finance/bank-account/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow(
            'error',
            t('error'),
            error.toString(),
            '',
            error.response
          );
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  useEffect(() => {
    apiCall('get', '/api/v2/company')
      .then(res => {
        const companies = res?.data?.data?.items || [];
        setCompanyOptions(companies);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString());
      });

    apiCall('get', '/api/v2/dictionary/currency')
      .then(response => {
        // const items = res?.data?.data?.items || [];
        // const uniqueCodes = Array.from(new Set(items.map(it => it.currency).filter(Boolean)));
        // const mappedCurrencies = uniqueCodes.map(code => ({ code }));
        setCurrencyOptions(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString());
      });

    if (action === 'update' && id) {
      setLoading(true);
      apiCall('get', '/api/v2/bank-account/' + id)
        .then(res => {
          const record = res?.data?.data || {};
          const normalizedCompany =
            record.company && record.company.id
              ? record.company.id
              : (typeof record.company === 'number' || typeof record.company === 'string'
                  ? record.company
                  : null);

          setFormData({
            ...record,
            company: normalizedCompany
          });
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString());
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [action, id, t]);

  useEffect(() => {
    if (!(action === 'update') && currencyOptions?.length && !formData.currency) {
      const def = process.env.REACT_APP_CURRENCY_DEFAULT || 'HUF';
      const hasDef = currencyOptions.some(c => (c.code ?? c) === def);
      if (hasDef) {
        setFormData(prev => ({ ...prev, currency: def }));
        setNewFormData(prev => ({ ...prev, currency: def }));
      }
    }
  }, [currencyOptions, action, id, formData.currency]);


  return (
    <div className={"bank-account-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0}} />
      }

      <Form
        onSubmit={onSubmit}
        initialValues={formData}
        validate={validate}
        render={({handleSubmit, submitting}) => (
          <form onSubmit={handleSubmit} className="">
            <div className="p-grid">

              <div className="p-col-12 p-lg-6">
                <Field name="company" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="company"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCompany')}</label>
                    <div className="field-control">
                      <Dropdown id="company" {...input}
                                value={
                                  formData?.company?.id
                                    ? formData.company.id
                                    : formData.company
                                }
                                options={window.App.sortDropdownOptions(companyOptions, "name")}
                                optionLabel="name"
                                optionValue="id"
                                placeholder={t('selectCompanyPlaceholder')}emptyMessage={t('noCompanyEmptyMessage')}
                                className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                onChange={(e) => {
                                  const value = e.value;
                                  setFormData({
                                    ...formData,
                                    company: value
                                  });
                                  setNewFormData({
                                    ...newFormData,
                                    company: value
                                  });
                                }}
                      />
                      {getFormErrorMessage(meta)}
                    </div>
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="currency" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="currency"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCurrency')}</label>
                    <div className="field-control">
                      <Dropdown id="currency" {...input}
                                value={formData.currency}
                                options={window.App.sortDropdownOptions(currencyOptions, "key")}
                                optionLabel="key"
                                optionValue="key"
                                placeholder={t('selectCurrencyPlaceholder')}emptyMessage={t('noCurrencyEmptyMessage')}
                                className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                onChange={(e) => {
                                  // const value = e.value;
                                  setFormData({
                                    ...formData,
                                    currency: e.target.value
                                  });
                                  setNewFormData({
                                    ...newFormData,
                                    currency: e.target.value
                                  });
                                }}
                      />
                      {getFormErrorMessage(meta)}
                    </div>
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="name" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="name"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                    <div className="field-control">
                      <InputText id="name" {...input}
                                 value={formData.name || ''}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   });
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   });
                                 }}
                                 placeholder={t('bankHufExamplePlaceholder')}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                      {getFormErrorMessage(meta)}
                    </div>
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="account_number" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="account_number"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAccountNumber')}</label>
                    <div className="field-control">
                      <InputText id="account_number" {...input}
                                 value={formData.account_number || ''}
                                 onChange={(e) => {
                                   const formatted = formatAccountNumber(e.target.value);
                                   setFormData({
                                     ...formData,
                                     account_number: formatted
                                   });
                                   setNewFormData({
                                     ...newFormData,
                                     account_number: formatted
                                   });
                                 }}
                                 placeholder={t('bankAccountExamplePlaceholder')}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                      {getFormErrorMessage(meta)}
                    </div>
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="iban" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="iban"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIban')}</label>
                    <div className="field-control">
                      <InputText id="iban" {...input}
                                 value={formData.iban || ''}
                                 onChange={(e) => {
                                   const formatted = formatIban(e.target.value);
                                   setFormData({
                                     ...formData,
                                     iban: formatted
                                   });
                                   setNewFormData({
                                     ...newFormData,
                                     iban: formatted
                                   });
                                 }}
                                 placeholder={t('ibanExamplePlaceholder')}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                      {getFormErrorMessage(meta)}
                    </div>
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="swift" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="swift"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldSwift')}</label>
                    <div className="field-control">
                      <InputText id="swift" {...input}
                                 value={formData.swift || ''}
                                 onChange={(e) => {
                                   const formatted = formatSwift(e.target.value);
                                   setFormData({
                                     ...formData,
                                     swift: formatted
                                   });
                                   setNewFormData({
                                     ...newFormData,
                                     swift: formatted
                                   });
                                 }}
                                 placeholder={t('swiftExamplePlaceholder')}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                      {getFormErrorMessage(meta)}
                    </div>
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="external_id" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="external_id"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('externalReference')}</label>
                    <div className="field-control">
                      <InputText id="external_id" {...input}
                                 value={formData.external_id || ''}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     external_id: e.target.value
                                   });
                                   setNewFormData({
                                     ...newFormData,
                                     external_id: e.target.value
                                   });
                                 }}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                      {getFormErrorMessage(meta)}
                    </div>
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                {/* üres jobb oldal, hogy az alsó switchek következő sorban szépen jöjjenek */}
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="default" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDefault')}</label>
                    <div className="field-control">
                      <InputSwitch
                        checked={!!formData.default}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            default: e.value
                          });
                          setNewFormData({
                            ...newFormData,
                            default: e.value
                          });
                        }}
                      />
                      {getFormErrorMessage(meta)}
                    </div>
                  </div>
                )}/>
              </div>

              <div className="p-col-12 p-lg-6">
                <Field name="active" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                    <div className="field-control">
                      <InputSwitch
                        checked={!!formData.active}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            active: e.value
                          });
                          setNewFormData({
                            ...newFormData,
                            active: e.value
                          });
                        }}
                      />
                      {getFormErrorMessage(meta)}
                    </div>
                  </div>
                )}/>
              </div>

            </div>

            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}></div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
                {entity === 'bank-account' &&
                  <Button type="submit"
                          label={t('save')}
                          loading={loading}
                          icon={"pi pi-save"}
                          className="p-button-success p-ml-2"/>
                }
                <Button type="submit"
                        label={t('saveAndBack')}
                        onClick={() => {
                          props = {...props, goback: true}
                        }}
                        loading={loading}
                        icon={"pi pi-arrow-left"}
                        className="p-button-success p-ml-2"/>
              </div>
            </div>
          </form>
        )}
      />
    </div>
  );
}

export default withTranslation('common')(BankaccountNumberFormComponent);
